export default __webpack_public_path__ + "static/media/purchasing.64b129b3.png";